import React from 'react'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { getReplyValue, findReplyByQuestionId } from '../../_helpers/pdfHelpers'
import { formatDate } from '@btime/helpers'

const clausules = [
  'O LOCATÁRIO é responsável pela posse do veículo do momento da retirada até a devolução.',
  'A LOCADORA poderá reter a caução por até 90 dias para fazer frente a eventuais despesas decorrentes da locação, que sejam notificadas após o término deste contrato.',
  'O LOCATÁRIO assume a inteira responsabilidade pela veracidade dos dados cadastrais contidos neste documento e nas declarações anexas. Sendo que qualquer alteração deverá ser comunicada imediatamente à LOCADORA para atualização cadastral.',
  'Para usufruir da cobertura de risco, o LOCATÁRIO deverá atender o disposto no item 7 das cláusulas gerais da contratação.',
  'O LOCATÁRIO nomeia e constitui a 2L LOCADORA DE VEÍCULOS LTDA como sua procuradora para firmar todos e quaisquer documentos, termos requerimentos e o que mais fizer necessário, sem qualquer exceção, a fim de indicar condutor e imputar pontuação decorrente das infrações à legislação de trânsito ocorridas no período de vigência deste contrato, incluindo possíveis renovações, nos termos do art. 257, Parágrafos 7º e 8º do Código de Trânsito Brasileiro, e Resolução CONTRAN 149/03, de 19 de setembro de 2003.',
  'O LOCATÁRIO afirma expressamente ter recebido uma cópia digital das condições gerais da contratação e do manual do cliente antes da assinatura do contrato _______________________.',
  'O LOCATÁRIO afirma expressamente ter recebido uma via física das condições gerais da contratação e do manual do cliente antes da assinatura do contrato, bem como foi informado que poderia consultar as condições gerais da locação e o manual do cliente a qualquer momento por meio dos endereços https://www.locadoraconcept.com.br/contrato e https://www.locadoraconcept.com.br/manual _______________________.'
]

const Footer = () => {
  const { replies, endDate } = useServiceOrder()

  const client = getReplyValue(findReplyByQuestionId(replies, 312)) || 'N/A'
  const formattedEndDate = endDate ? formatDate('DD/MM/YYYY HH:mm', endDate) : ''

  return (
    <View>
      <Text size={12} style={{ textAlign: 'justify' }}>
        Por meio deste instrumento particular, LOCATÁRIO e LOCADORA celebram o CONTRATO de locação de veículo acima
        relacionado, nos termos abaixo descritos:
      </Text>

      <Separator weight={1} />

      {clausules.map((clausula, i) => (
        <Text key={i} size={12} style={{ textAlign: 'left', marginTop: 2 }}>
          <span style={{ fontWeight: 'bold' }}>{i + 1}.</span> {clausula}
        </Text>
      ))}

      <Separator weight={5} />

      <Text size={11}>Curitiba {formattedEndDate ? `, ${formattedEndDate}` : ''}</Text>

      <Separator weight={7} />

      <Text align="center" bold>
        _________________________________________________________________
      </Text>
      <Text align="center" bold>
        {client?.toUpperCase()}
      </Text>
      <Text align="center" size={10}>
        Assinatura como na CNH
      </Text>
    </View>
  )
}

export default Footer
